import { z } from "zod";

export const CreateLinkBody = z.object({
  url: z.string().url().max(2048),
  customCode: z
    .string()
    .min(4)
    .max(32)
    .regex(/^[A-Za-z0-9_-]+$/)
    .optional(),
  expiresAt: z.string().datetime({ offset: true }).optional(),
});
export type CreateLinkBody = z.infer<typeof CreateLinkBody>;

export const UpdateLinkBody = z
  .object({
    destinationUrl: z.string().url().max(2048).optional(),
    expiresAt: z.string().datetime({ offset: true }).nullable().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((b) => Object.keys(b).length > 0, {
    message: "At least one field must be provided",
  });
export type UpdateLinkBody = z.infer<typeof UpdateLinkBody>;

export const ListLinksQuery = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});
export type ListLinksQuery = z.infer<typeof ListLinksQuery>;

export const LinkDTO = z.object({
  id: z.string().uuid(),
  code: z.string(),
  shortUrl: z.string().url(),
  destinationUrl: z.string().url(),
  workspaceId: z.string().uuid(),
  isActive: z.boolean(),
  expiresAt: z.string().datetime({ offset: true }).nullable(),
  clickCount: z.number().int().nonnegative(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type LinkDTO = z.infer<typeof LinkDTO>;

export const ListLinksResponse = z.object({
  items: z.array(LinkDTO),
  total: z.number().int().nonnegative(),
  limit: z.number().int(),
  offset: z.number().int(),
});
export type ListLinksResponse = z.infer<typeof ListLinksResponse>;

export const MeResponse = z.object({
  user: z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().nullable(),
  }),
  workspace: z.object({
    id: z.string().uuid(),
    name: z.string(),
  }),
});
export type MeResponse = z.infer<typeof MeResponse>;

export const ErrorResponse = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ErrorResponse = z.infer<typeof ErrorResponse>;
